module.exports = __webpack_public_path__ + "static/media/mongodb.2d9a9456.png";